// Module
var code = `<div class="svc-matrix-cell" tabindex="-1" data-bind="click: selectContext, event: { mouseover: function(m, e) { hover(e, \$element); }, mouseleave: function(m, e) { hover(e, \$element); } }">
  <div class="svc-matrix-cell--selected" data-bind="css: { 'svc-visible': isSelected }"></div>

  <!-- ko component: { name: 'sv-template-renderer', params: { componentData: null, templateData: templateData } } -->
  <!-- /ko -->

  <!-- ko if: \$data.isSupportCellEditor -->
  <div class="svc-matrix-cell__question-controls">
    <sv-svg-icon class="svc-matrix-cell__question-controls-button svc-context-button" data-bind="click: editQuestion, key2click" params="iconName: 'icon-edit', size: 'auto'"></sv-svg-icon>
  </div>
  <!-- /ko -->

</div>`;
// Exports
export default code;